import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { PaymentMethods } from '@/src/interfaces/system/payment-method'
import { usePaymentMethod } from '@/src/hooks/usePaymentMethods'
import Merchant from '@/src/interfaces/merchant/merchant'

interface Props {
    paymentConfiguration: Merchant.PaymentConfiguration
}

enum OnlinePaymentEnum {
    credit = 3,
    debit = 4
}

export default function TypePayments({ paymentConfiguration }: Props) {
    const paymentOfflineAvailable = paymentConfiguration?.offinePaymentEnabled && paymentConfiguration?.offlineConfiguration?.paymentMethods?.length > 0
    const paymentOnlineAvailable = paymentConfiguration?.onlinePaymentEnabled && (paymentConfiguration?.onlineConfiguration?.creditCardEnabled || paymentConfiguration?.onlineConfiguration?.pixEnabled)
    const { mapOfflinePayment } = usePaymentMethod()
    const [customPaymentMethods, setCustomPaymentMethods] = useState<PaymentMethods[]>()

    useEffect(() => {
        const paymentList = mapOfflinePayment(paymentConfiguration)
        setCustomPaymentMethods(paymentList)
    }, [])

    return (
        <div className={styles.container}>
            <h2 className={`${styles.title} font-lg`}>Formas de Pagamento</h2>
            <div className={styles.typePayment}>
                <div className={styles.contentMethods}>

                    {
                        paymentOnlineAvailable && (
                            <>
                                <p className={styles.methodTitle}>Pagamento online:</p>
                                <div className={styles.contentOptions}>
                                    {
                                        <>
                                            {paymentConfiguration.onlineConfiguration?.creditCardEnabled && <span className={`${styles.option} font-sm`}>Cartão de crédito</span>}
                                            {paymentConfiguration.onlineConfiguration.pixEnabled && <span className={`${styles.option} font-sm`}>Pix</span>}
                                        </>
                                    }
                                </div>
                            </>
                        )
                    }
                    {
                        paymentOfflineAvailable && (
                            <>
                                <p className={styles.methodTitle}>Na entrega:</p>
                                <div className={styles.contentOptions}>
                                    {
                                        customPaymentMethods && customPaymentMethods.map((item, index) => (
                                            <span key={index} className={`${styles.option} font-sm`}>{item.name}</span>
                                        ))
                                    }
                                </div>
                            </>
                        )
                    }
                </div>
            </div>
        </div>
    )
}
